import { useBusinessOrganizationPricingConfig } from '@sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useGeneratedGetPricingHubCustomersQuery } from '@sales-portal/domain/pricing/screens/overview/blocs/documents/pricing-hub-customers.generated';
import { useMemo } from 'react';

export const usePricingHubCustomersLoader = () => {
  const { hasCustomerTableAccess } = useBusinessOrganizationPricingConfig();

  const { data, error, loading } = useGeneratedGetPricingHubCustomersQuery({
    fetchPolicy: 'cache-and-network',
    skip: !hasCustomerTableAccess,
  });

  return useMemo(
    () => ({
      customers: data?.getPricingHubCustomers,
      error,
      isLoading: loading && !data,
    }),
    [data, error, loading],
  );
};
